<script>
import isEmpty from 'lodash/isEmpty'
import toString from 'lodash/toString'
export default {
  toString,
  props: {
    veeName: {
      type: String,
      require: false,
      default: '',
    },
    /**
     * rules vee-validate https://vee-validate.logaretm.com/v2/guide/rules.html
     */
    rules: {
      type: [Object, Boolean],
      require: false,
      default: () => {},
    },
    options: {
      type: Array,
      required: true,
    },
    checked: {
      type: [String, Number],
      require: true,
      default: '',
    },
    name: {
      type: String,
      require: true,
      default: '',
    },
    custom: Boolean,
    inline: Boolean,
  },
  data() {
    return {
      trick: this.checked, // hack for vee-validate
    }
  },
  computed: {
    isValidate() {
      if (this.rules && !isEmpty(this.rules)) {
        return 'is-valid'
      }
      return ''
    },
    rulesComputed() {
      if (this.rules) {
        return this.rules
      }
      return {}
    },
    computedOptions() {
      const data = this.options.map((option) => {
        if (typeof option !== 'object') {
          return {
            label: option,
            value: option,
          }
        }
        return option
      })
      return data
    },
    groupName() {
      return this.name || 'radio' + this._uid
    },
  },
  methods: {
    getValidationState({ dirty, validated, valid = null, ...rest }) {
      return dirty || validated ? valid : null
    },
    change(e, option) {
      this.$emit('update:checked', option, e)
    },
  },
}
</script>

<template>
  <validation-provider
    v-slot="validationContext"
    :rules="rulesComputed"
    :name="veeName"
  >
    <div id="feelline-base-radio-group" :class="{ 'form-group': inline }">
      <div :class="{ 'form-inline': inline }">
        <CInputRadio
          v-for="({ value, label, props }, key) in computedOptions"
          :key="key"
          v-model="trick"
          :label="label"
          :name="groupName"
          :value="value"
          :checked="$options.toString(checked) === value"
          :custom="custom"
          :inline="inline"
          v-bind="{ ...props, ...$attrs }"
          @change="change($event, value)"
        />
      </div>
      <span class="text-danger">{{ validationContext.errors[0] }}</span>
    </div>
  </validation-provider>
</template>
